export enum DistributionStatusBarTypeEnum {
    BAR = 'bar',
    ICON = 'icon',
}
